import {
  account,
  batches, binData,
  blockchainUrl,
  cashFlow,
  connectedServices,
  currencies,
  defaultFee,
  exchanger,
  fee,
  logs,
  masterBalance,
  masterRefilling,
  navbar,
  nickname,
  payment,
  payout,
  project,
  rates,
  service, serviceBalance,
  supportUser, swap, systemCommand, telegramBot, transactions,
  transfer, userAdminFields,
  users,
  walletDetails, walletMainWhitelist, wallets, walletWhitelist
} from "./rbac-consts";

const rules = {
  ROLE_SUPPORT: {
    static: [
      navbar.HOME,
      navbar.ACCOUNT,
      navbar.PAYMENTS,
      navbar.PAYOUTS,
      account.SUPPORT,
      payment.SUPPORT,
      payout.SUPPORT
    ]
  },
  ROLE_ADMIN: {
    static: [
      navbar.HOME,
      navbar.ACCOUNT,
      navbar.SERVICES,
      navbar.CURRENCIES,
      navbar.FEE,
      navbar.USERS,
      navbar.RATES,
      navbar.BIN_DATA,
      navbar.DEFAULT_FEE,
      navbar.BASE_RATES,
      navbar.BATCHES,
      navbar.LOGS,
      navbar.TRANSFER,
      navbar.BLOCKCHAIN_URL,
      navbar.CASH_FLOW,
      navbar.WALLET_MAIN_WHITELIST,
      currencies.ADMIN,
      account.ADMIN,
      service.ADMIN,
      service.CLIENT_LIST,
      fee.ADMIN,
      users.ADMIN,
      nickname.CHANGE,
      payment.ADMIN,
      payout.ADMIN,
      defaultFee.ADMIN,
      rates.ADMIN,
      batches.ADMIN,
      logs.ADMIN,
      blockchainUrl.ADMIN,
      cashFlow.ADMIN,
      transfer.ADMIN,
      binData.ADMIN,
      exchanger.ADMIN,
      serviceBalance.ADMIN,
      wallets.ADMIN,
      walletDetails.ADMIN,
      walletMainWhitelist.ADMIN,
      walletWhitelist.ADMIN,
    ]
  },
  ROLE_USER: {
    static: [
      navbar.HOME,
      navbar.ACCOUNT,
      navbar.PROJECTS,
      navbar.SERVICES,
      navbar.CONNECTIONS,
      navbar.PAYMENTS,
      navbar.PAYOUTS,
      navbar.TRANSFER,
      navbar.EXCHANGE,
      navbar.RATES,
      navbar.CLIENT_FEES,
      navbar.BATCHES,
      navbar.CASH_FLOW,
      navbar.WALLETS,
      navbar.WALLET_WHITELIST,
      account.USER,
      service.USER,
      connectedServices.USER,
      payment.USER,
      payout.USER,
      transfer.USER,
      exchanger.USER,
      project.USER,
      batches.USER,
      rates.USER,
      fee.USER,
      cashFlow.USER,
      wallets.USER,
      walletDetails.USER,
      walletWhitelist.USER,
      navbar.TELEGRAM_BOT,
      telegramBot.USER,
    ]
  },
  ROLE_SUPER_ADMIN: {
    static: [
      navbar.HOME,
      navbar.USERS,
      navbar.TRANSACTIONS,
      navbar.PAYMENTS,
      navbar.PAYOUTS,
      navbar.SUPPORT_USER,
      navbar.SYSTEM_COMMAND,
      navbar.SERVICES_BALANCES,
      transactions.SUPER_ADMIN,
      payout.SUPER_ADMIN,
      payment.SUPER_ADMIN,
      service.SUPER_ADMIN,
      service.CLIENT_LIST,
      users.SUPER_ADMIN,
      supportUser.SUPER_ADMIN,
      systemCommand.SUPER_ADMIN,
      nickname.CHANGE,
      serviceBalance.SUPER_ADMIN,
      userAdminFields.CHANGE
    ]
  },
  ROLE_MASTER: {
    static: [
      navbar.HOME,
      navbar.MASTER_BALANCE,
      navbar.MASTER_REFILLING,
      navbar.SWAP,
      navbar.EXCHANGE,
      masterBalance.MASTER,
      masterRefilling.MASTER,
      exchanger.MASTER,
      swap.MASTER
    ]
  },
  ROLE_PAIR_UNIT_MANAGER: {
    static: [
      navbar.HOME,
      navbar.ACCOUNT,
      navbar.FEE,
      navbar.RATES,
      account.ADMIN,
      fee.PAIR_UNIT_MANAGER,
      rates.PAIR_UNIT_MANAGER,
    ]
  }
};

export default rules;
